import React from 'react'
import style from './Loading.module.css'
import { ThreeDots } from 'react-loader-spinner'

export default function Loading() {

    const site = sessionStorage.getItem('desiredPage')

  return <>
  <div className={`position-fixed m-0 ${style.loadingIndex} top-0 start-0 end-0 bottom-0 bg-white d-flex justify-content-center align-items-center`}>
    <ThreeDots
    visible={true}
    height="80"
    width="80"
    color={site ==='company'? "#A39056":"#ECAA1E"}
    radius="9"
    ariaLabel="three-dots-loading"
    wrapperStyle={{}}
    wrapperClass=""
    />
  </div>
  </>
}
